import { FC } from "react";
import { useTranslation } from "react-i18next";
import { images } from "../images";

export const CreateYourMemoriesCard: FC = () => {
  const { t } = useTranslation();
  const createMemoirsUrl = import.meta.env.VITE_MEMOIRS_SELL_PRINT_URL;

  return (
    <div className="bg-white w-full flex flex-col justify-between shadow-md rounded py-6 sm:py-8 px-4 sm:px-6">
      <div className="flex flex-col w-full items-center">
        <h2 className="text-slate-700 text-2xl sm:text-3xl lg:text-4xl font-bold text-center mb-2 sm:mb-2">
          {t("anecdotes.contribute.success.createYourMemoirs")}
        </h2>
        <p className="text-slate-700 text-l sm:text-xl lg:text-2xl font-bold text-center mb-6 sm:mb-8">
          {t("anecdotes.contribute.success.createYourMemoirs2")}
        </p>

        <div className="flex flex-col lg:flex-row w-full items-center justify-center gap-6 lg:gap-8">
          <div className="w-full lg:w-1/2 max-w-md">
            <img
              alt="Memoirs logo"
              src={images.Upsell}
              className="w-full h-auto rounded-lg"
            />
          </div>

          <div className="w-full lg:w-1/2 max-w-lg flex flex-col items-center lg:items-start">
            <div
              className="text-slate-700 text-base sm:text-lg lg:text-xl leading-relaxed mb-6 sm:mb-8 text-center lg:text-left"
              dangerouslySetInnerHTML={{
                __html: t(
                  "anecdotes.contribute.success.startMemoirsDescription",
                  {
                    interpolation: {
                      escapeValue: false,
                    },
                  }
                ),
              }}
            />

            <div className="flex flex-col sm:flex-row w-full gap-4 items-center lg:items-start">
              <a
                href={createMemoirsUrl}
                target="blank"
                className="w-full sm:w-auto flex items-center justify-center bg-sand-500 hover:bg-sand-600 text-white text-base sm:text-lg font-semibold rounded-lg px-6 py-3 transition-colors duration-200"
              >
                {t("anecdotes.contribute.success.startMemoirs")}
              </a>
              <a
                href={createMemoirsUrl}
                target="blank"
                className="w-full sm:w-auto flex items-center justify-center bg-delicate-500 hover:bg-delicate-600 text-white text-base sm:text-lg font-semibold rounded-lg px-6 py-3 transition-colors duration-200"
              >
                {t("anecdotes.contribute.success.giftMemoirs")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
